import React, { useState, useEffect } from 'react';
import { CONFIG } from '../config/global';

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              src={CONFIG.company.logo.src}
              alt={CONFIG.company.logo.alt}
              width={CONFIG.company.logo.width}
              height={CONFIG.company.logo.height}
              className="h-8 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => scrollToSection('about')}
              className={`hover:text-primary transition-colors duration-200 ${
                isScrolled ? 'text-text' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`hover:text-primary transition-colors duration-200 ${
                isScrolled ? 'text-text' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`hover:text-primary transition-colors duration-200 ${
                isScrolled ? 'text-text' : 'text-white'
              }`}
            >
              Pricing
            </button>
            <button
              onClick={() => window.open(CONFIG.loginLink, '_self')}
              className="bg-gray-800/80 backdrop-blur-sm border-2 border-white text-white px-4 py-2 rounded-full transition-all duration-200 hover:bg-gray-700 hover:border-gray-300 shadow-lg"
            >
              Login
            </button>
            <button
              onClick={() => window.open(CONFIG.calendlyLink, '_blank')}
              className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-full transition-all duration-200"
            >
              Get Started
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-md ${
                isScrolled ? 'text-text' : 'text-white'
              }`}
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md rounded-lg mt-2 py-4 shadow-lg">
            <div className="flex flex-col space-y-4 px-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-text hover:text-primary transition-colors duration-200 text-left"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="text-text hover:text-primary transition-colors duration-200 text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-text hover:text-primary transition-colors duration-200 text-left"
              >
                Pricing
              </button>
              <button
                onClick={() => window.open(CONFIG.loginLink, '_blank')}
                className="text-text hover:text-primary transition-colors duration-200 text-left border-b border-gray-200 pb-2"
              >
                Login
              </button>
              <button
                onClick={() => window.open(CONFIG.calendlyLink, '_blank')}
                className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-full transition-all duration-200 text-left"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
